/**
 * NFC normalization entry point. Every Doc passes through here before
 * tokenization — parsers (notably pdf.js) emit decomposed sequences, and all
 * downstream indexing assumes composed clusters (soul.md §7, PRD §7.2).
 */
export function normalizeText(text) {
    return text.normalize('NFC');
}
export function normalizeDoc(doc) {
    return {
        lang: doc.lang,
        blocks: doc.blocks.map((block) => ({
            kind: block.kind,
            text: normalizeText(block.text),
            title: block.title === undefined ? undefined : normalizeText(block.title),
        })),
    };
}
//# sourceMappingURL=normalize.js.map